import * as Enum from '../utils/enums';
import * as FileSaver from 'file-saver';
export class Util {

    /**
     * show pdf
     * @param response response from services
     */
    static showPdf(response: any) {
        let pdfString = response
        //Detect browser used
        //var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
        //var isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;

        if (isChrome) {
            // base64 string
            var base64str = pdfString;

            // decode base64 string, remove space for IE compatibility
            var binary = atob(base64str.replace(/\s/g, ''));
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }

            // create the blob object with content-type "application/pdf"               
            var blob = new Blob([view], { type: "application/pdf" });
            var url = URL.createObjectURL(blob);

            window.open(url, "_blank")
        }
        else {  //it works on Safari e Firefox 
            window.open("data:application/pdf;base64," + pdfString, "_blank")
        }
    }


    /**
     * download other file
     * @param response response from service
     * @param type type of file
     * @param name name of file
     */
    static downloadFile(response: any, type: string, name: string) {
        let fileType = ""
        let stringDecoded: any
        //switch type of file and set fileType and string decoded
        switch (type) {
            case Enum.FILE_TYPE_ENUM.XLS:
                fileType = "application/vnd.ms-excel;charset=utf-8"
                stringDecoded = this.s2ab(atob(response))
                break
            case Enum.FILE_TYPE_ENUM.XLSX:
                fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                stringDecoded = this.s2ab(atob(response))
                break
            case Enum.FILE_TYPE_ENUM.DOC:
            case Enum.FILE_TYPE_ENUM.DOCX:
                fileType = "application/msword;charset=utf-8"
                stringDecoded = this.s2ab(atob(response))
                break
            case Enum.FILE_TYPE_ENUM.PPT:
            case Enum.FILE_TYPE_ENUM.PPTX:
                fileType = "application/vnd.ms-powerpoint;charset=utf-8"
                stringDecoded = this.s2ab(atob(response))
                break
            default: //case Enum.FILE_TYPE_ENUM.TXT:
                fileType = "text/plain;charset=utf-8"
                stringDecoded = atob(response)
        }

        let blob = new Blob([stringDecoded], {
            type: fileType
        })
        FileSaver.saveAs(blob, name)
    }

    static s2ab(s: any) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }


    /**
     * check empty string
     * @param str 
     * @returns 
     */
    static isBlank(str) {
        return (!str || /^\s*$/.test(str));
    }
}